export default {
  fontSize: '1rem',
  borderRadius: '1rem',
};
